import {
  Button,
  Card,
  FooterMenu,
  HeaderMenu,
  PermissionLink
} from "components"
import { debounce } from "lodash"
import { Fragment, useState } from "react"
import { TbChevronRight } from "react-icons/tb"
import { PaginationState } from "types"
import { default_pagination_value } from "utils"
import { TableSection } from "./components/TableSection"
import { exportExcel, useExportPdf, useGetAllOpeningStock, useList } from "./utils"
import { ModalExportApprovalOpeningStock } from "../ApprovalOpeningStock/components"
import { IsOpenModal } from "../ApprovalOpeningStock"

export default function OpeningStock() {
  const [pagination, setPagination] = useState<PaginationState>(default_pagination_value)
  const list = useList(pagination)
  const exportPdf = useExportPdf({ data: list.data?.payload })

  const getAllOpeningStock = useGetAllOpeningStock()
  const amount = Math.min(getAllOpeningStock?.data?.length ?? 0, 10);

  const [isOpenModal, setIsOpenModal] = useState<IsOpenModal>({
    isOpen: false,
    type: "",
    amount: 10
  })

  const sortMapping: Record<string, string> = {
    "OPENING DATE": "date",
    BARCODE: "barcode",
    "ITEM NAME": "product",
    STOCK: "soh",
    UNIT: "unit",
    "AVERAGE PRICE UNIT": "price",
    LOCATION: "location"
  }
  const onDebounce = debounce((e: any) =>
    setPagination((prev) => {
      return {
        ...prev,
        keyword: e.target.value
      }
    })
  )
  const handleSort = (item: string, sortType: string) => {
    const sortParam = sortMapping[item]
      ? `${sortMapping[item]}:${sortType}`
      : ""
    setPagination({ ...pagination, sort: sortParam, page: 1 })
  }

  const handleExportExcel = () => {
    const slicedData = getAllOpeningStock?.data?.slice(0, isOpenModal?.amount) ?? []
    exportExcel({ data: slicedData })
    setIsOpenModal({ isOpen: false, type: "", amount: 10 })
  }

  return (
    <Fragment>
      <section className="container my-2">
        <section>
          <HeaderMenu title="DATA ENTRY | OPENING STOCK" />
          <section className="mt-2">
            <Card>
              <Card.Body>
                <div className="mb-3 justify-end flex">
                  <PermissionLink
                    permission={"IT081"}
                    to={"/setup/inventory/opening-stock/create"}>
                    <Button permission="IT081" color="primary">
                      OPENING STOCK <TbChevronRight />
                    </Button>
                  </PermissionLink>
                </div>
                <TableSection
                  list={list}
                  onDebounce={onDebounce}
                  handleSort={handleSort}
                  pagination={pagination}
                  setPagination={setPagination}
                />
              </Card.Body>
            </Card>
          </section>

          <section className="mt-2">
            <FooterMenu
              hasCancelButton
              export={{
                actiontype: "export",
                onClick: () => setIsOpenModal({ ...isOpenModal, isOpen: true, type: "excel", amount: amount })
              }}
              pdf={{
                actiontype: "pdf", 
                onClick: () => exportPdf.handleExportPdf()
              }}
            />

            {/* Modal Export */}
            <ModalExportApprovalOpeningStock
              label="Export Opening Stock"
              show={isOpenModal.isOpen} 
              onHide={() => setIsOpenModal({ isOpen: false, type: "", amount: 10 })} 
              maxAmount={getAllOpeningStock?.data?.length}
              amount={isOpenModal?.amount}
              setAmount={(amount) => setIsOpenModal({ ...isOpenModal, amount: amount })}
              onButtonExportClick={handleExportExcel}
            />
          </section>
        </section>
      </section>
    </Fragment>
  )
}
